<!--
 * @Author: shijian.chen
 * @Date: 2021-11-09 16:52:12
 * @LastEditTime: 2023-03-24 00:07:32
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 领克广告
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/ftms/index.vue
-->
<template>
  <div class="taizhou">
    <div v-show="homePage != '2'" class="banner">
      <img
        src="https://source.qunarzz.com/site/images/wns/20230222-shijianchen-banner.png"
        alt=""
      />
      <div v-if="homePage != '2'" class="videobg" @click="showVideo">
        <img
          src="https://source.qunarzz.com/site/images/wns/20221115-shijianchen-poster.jpeg"
          alt=""
        />
        <img src="https://source.qunarzz.com/site/images/wns/20230322-shijianchen-play.png" class="play" alt="">
      </div>
    </div>
    <div v-show="homePage == '2'" class="banner2">
      <img
        src="https://source.qunarzz.com/site/images/wns/20230222-shijianchen-banner.png"
        alt=""
      />
    </div>
    <div v-if="homePage != '2'" class="box">
      <div class="tabs">
        <div
          class="tab"
          @click="toggle(index)"
          :class="{ active: current == index }"
          v-for="(item, index) in tabs"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <!-- <img id="theme" class="boxTit1" :src="json.boxTit1" alt="" /> -->
      <div id="theme" class="boxTit1">泰州夏季旅游线路推荐</div>
      <div class="boxBg3">
        <img
          src="https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-box1.png"
          class="boxBgImg3"
          alt=""
        />
        <div class="lineList">
          <div
            v-for="(item, index) in json.lineList"
            :key="index"
            v-show="(!lookMore4 && index < 2) || lookMore4"
            @click="showLineDetail(item)"
            class="lineItem"
          >
            <div class="lineItem-lf">
              <img :src="item.img" alt="" />
            </div>
            <div class="lineItem-rt">
              <div class="lineItem-rt-txt">
                {{ item.text }}
              </div>
              <div class="lineItem-rt-des text-overflow">
                {{
                  item.content
                    ? item.content
                    : item.detail && item.detail.html[0]
                }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="!lookMore4" @click="lookMore4 = true" class="lookMore3">
          查看更多
        </div>
      </div>
      <div id="daka" class="boxTit1">幸福泰州 网红打卡</div>
      <div @click="jumpToDaka(2)" class="boxBg2">
        <img :src="json.boxBg2" alt="" />
      </div>
      <div id="zixun" class="boxTit1">热门资讯早知道</div>
      <div class="boxBg4">
        <img
          src="https://source.qunarzz.com/site/images/wns/20230222-shijianchen-bg1.png"
          class="boxBgImg4"
          alt=""
        />
        <div class="zixunList">
          <a
            :href="item.link"
            v-maidian="'zixun' + index"
            class="zixunItem"
            v-for="(item, index) in json.zixunList"
            v-show="(!lookMore && index < 2) || lookMore"
            :key="index"
          >
            <div class="zixunItem-lf">
              <p class="text-overflow zixunItem-tit">{{ item.title }}</p>
              <p class="text-overflow zixunItem-des">{{ item.des }}</p>
            </div>
            <div class="zixunItem-rt">
              <img :src="item.img" alt="" />
            </div>
          </a>
        </div>
        <div v-if="!lookMore" @click="lookMore = true" class="lookMore">
          查看更多资讯
        </div>
      </div>
      <div id="shop" class="boxTit1">「泰」好玩旅行商城</div>
      <div class="newBox">
        <div class="ticketTit">
          <img
            src="https://source.qunarzz.com/site/images/wns/20230222-shijianchen-tit-2.png"
            alt=""
          />
        </div>
        <div class="newBoxChild">
          <div class="hotelList">
            <a
              :href="item.link"
              v-for="(item, index) in json.hotelList"
              :key="index"
              v-maidian="'ticket-' + index"
              v-show="(!lookMore2 && index < 4) || lookMore2"
              class="hotelItem"
            >
              <div class="hotelItem-tp">
                <img :src="item.img" alt="" />
              </div>
              <div class="hotelItem-cont text-overflow">{{ item.tit }}</div>
              <div class="hotelItem-btm">
                <span class="hotelItem-price">{{ item.price }}</span>
                <span class="hotelItem-look">查看</span>
              </div>
            </a>
          </div>
          <div v-if="!lookMore2" @click="lookMore2 = true" class="lookMore2">
            查看更多
          </div>
        </div>
      </div>
      <div class="newBox">
        <div class="hotelTit">
          <img
            src="https://source.qunarzz.com/site/images/wns/20230222-shijianchen-tit-1.png"
            alt=""
          />
        </div>
        <div class="newBoxChild">
          <div class="hotelList">
            <a
              :href="item.link"
              v-for="(item, index) in json.hotelList2"
              :key="index"
              v-show="(!lookMore3 && index < 4) || lookMore3"
              class="hotelItem"
              v-maidian="'hotel-' + index"
            >
              <div class="hotelItem-tp">
                <img :src="item.img" alt="" />
              </div>
              <div class="hotelItem-cont text-overflow">{{ item.tit }}</div>
              <div class="hotelItem-btm">
                <span class="hotelItem-price">{{ item.price }}</span>
                <span class="hotelItem-look">预订</span>
              </div>
            </a>
          </div>
          <div v-if="!lookMore3" @click="lookMore3 = true" class="lookMore2">
            查看更多
          </div>
        </div>
      </div>
    </div>
    <div style="position: relative; z-index: 2" v-else>
      <div class="tabs2Fluid">
        <div class="tabs2">
          <div
            class="tab NotoSansCJKscRegular"
            @click="toggle2(index)"
            :class="{ active: current2 == index }"
            v-for="(item, index) in tabs2"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in wanghong[current2]"
        :key="index"
        class="wanghongContent-it"
      >
        <div class="wanghongContent-tp">{{ item.title }}</div>
        <div class="wanghongContent-box">
          <mt-swipe class="wanghongContent-img" :auto="0">
            <mt-swipe-item v-for="(child, index) in item.imgs" :key="index">
              <img :src="child" alt="" />
            </mt-swipe-item>
          </mt-swipe>
          <div class="wanghongContent-box-rt">
            <div @click="showDetail(item)" class="detail-btn">详细信息</div>
            <!-- <div class="vote-ticketNum">
              已获<span class="ticket">401</span>票
            </div>
            <div class="vote-btn">我要投票</div> -->
          </div>
        </div>
      </div>
    </div>
    <a
      v-maidian="'dalibao'"
      v-if="homePage != '2'"
      href="https://m.flight.qunar.com/shark/active/b8e4897a9b9c7498080bc04d78e146e2?activityNo=sdcp-tzswlj&bdsource=sdcp-tzswlj&channel=sdcp-tzswlj&grantType=qunar
"
      class="bottom"
    >
      <img
        src="https://source.qunarzz.com/site/images/wns/20221118-shijianchen-quan.png"
        alt=""
      />
    </a>
  </div>
</template>
<script>
import { query } from '@/utils/getJson';
import wanghong from './components/dialog/justShow/index';
import showVideo from './components/dialog/wanghong/index';
import videoComp from './components/video.vue';
import $ from 'jquery';
export default {
  components: {
    videoComp,
  },
  data() {
    return {
      current: 0,
      lookMore: false,
      lookMore2: false,
      lookMore3: false,
      lookMore4: false,
      lookMore5: false,
      homePage: 0,
      current2: 0,
      json: {
        banner:
          'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-1.jpg',
        boxTit1:
          'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-1.png',
        boxTit2:
          'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-tit3.png',
        boxTit3:
          'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-tit4.png',
        boxTit4:
          'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-tit5.png',
        boxBg:
          'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-box1.png',
        boxBg2:
          'https://source.qunarzz.com/site/images/wns/20230222-shijianchen-look1.jpg',
        boxBg3:
          'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-box2.png',
        video: {
          bg2: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-2.png',
          src: '',
          poster: '',
        },
        lineList: [
          {
            img: 'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_1_head.jpg',
            text: '“寻古访今”研学游',
            detail: {
              title: '“寻古访今”研学游',
              html: [
                '线路一：望海楼——泰州博物馆——口岸雕花楼—泰兴黄桥古镇——靖江生祠岳庙',
                [
                  'https://source.qunarzz.com/site/images/wns/20230713_taizhou_travel_1_line_1_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/20230713_taizhou_travel_1_line_1_2.png',
                ],
                '线路二：梅兰芳公园——崇儒祠——学政试院——乔园——江苏盐税博物馆——夜游凤城河',
                [
                  'https://source.qunarzz.com/site/images/wns/20230713_taizhou_travel_1_line_2_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/20230713_taizhou_travel_1_line_2_2.jpg',
                  'https://source.qunarzz.com/site/images/wns/20230713_taizhou_travel_1_line_2_3.jpg',
                ],
                '线路三：姜堰古罗塘街区——溱潼古镇——兴化郑板桥·范仲淹纪念馆——施耐庵文化园',
                [
                  'https://source.qunarzz.com/site/images/wns/20230713_taizhou_travel_1_line_3_2.png',
                ],
                '线路四：新四军黄桥战役纪念馆——海军诞生地纪念馆——海军舰艇文化园——蒋垛苏维埃公园',
                [
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_1_line_4_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_1_line_4_2.jpg',
                ],
              ],
            },
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_2_head.jpg',
            text: '“清凉一夏”亲水游',
            detail: {
              title: '“清凉一夏”亲水游',
              html: [
                '线路一：凤城河划龙舟——秋雪湖·欢乐水世界——泰州华侨城“冷泉·水世界”',
                [
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_2_line_1_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_2_line_1_2.jpg',
                ],
                '线路二：秋雪湖·童话森林——溱湖国家湿地公园——李中水上森林公园——兴化万亩荷塘',
                [
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_2_line_2_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_2_line_2_2.jpg',
                ],
              ],
            },
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_3_head.jpg',
            text: '“嗨玩夏日”亲子游',
            detail: {
              title: '“嗨玩夏日”亲子游',
              html: [
                '线路一：凤城河“研学夏令营”——稻河古街区“意趣夏令营”——小机长研学营——爱情海·欢乐田园“海陆空军事夏令营”——溱湖绿洲“渔窑耕读夏令营”——姜堰“海军研学夏令营”——兴化里下河音乐节',
                [
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_3_line_1_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_3_line_1_2.jpg',
                ],
                '线路二：靖江丽园、锦秀山庄——泰兴祁巷小南湖（暑期乐翻天）——秋雪湖·花栖云里（“植”此青绿园艺研学）——稻河古街区（墨韵艺术工作室）',
                [
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_3_line_2_1.png',
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_3_line_2_2.jpg',
                ],
                '线路三：爱情海·欢乐田园（梦幻奇妙夜）——凤城河“夜泰美·凤城往事”——泰FUN市集——三河湾烟火市集',
                [
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_3_line_3_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_3_line_3_2.jpg',
                ],
              ],
            },
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_4_head.jpg',
            text: '“田园野趣”采摘游',
            detail: {
              title: '“田园野趣”采摘游',
              html: [
                '线路一：高港陈家村（国家级乡村旅游重点村）——泰兴市曲霞镇——泰兴旭日丰农场——靖江徐周村（省级乡村旅游重点村）',
                [
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_4_line_1_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_4_line_1_2.jpg',
                ],
                '线路二：海陵麒麟村（省级乡村旅游重点村）——秋雪湖·尚品果园——姜堰鲜果采摘节（各镇、街采摘点）——兴化陈杨村',
                [
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_4_line_2_1.jpg',
                  'https://source.qunarzz.com/site/images/wns/202307_taizhou_travel_4_line_2_2.jpg',
                ],
                '此次推荐的线路产品融合了从幼儿园至大学不同学龄的学生，同时兼顾亲子家庭的出游需求，按照产品内容的主题划分类别，为广大家长和学生的出游提供指引。',
              ],
            },
          },
        ],
        zixunList: [
          {
            img: 'https://source.qunarzz.com/site/images/wns/202310_taizhou_zixun_1.jpg',
            title: '2023“寻味泰州”水城蟹乡美食旅游季活动汇总表',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=5c824dd4b2b7607da8cdda12514fd95d',
            des: '',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/202310_taizhou_zixun_2.jpeg',
            title: '2023“寻味泰州”水城蟹乡美食旅游季情况',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=bc5057c12e2efed4653df49689c9029f',
            des: '',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/202307_taizhou_zixun_1.jpg',
            title: '2023“幸福泰州 缤纷夏日”文旅消费季活动汇总表',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=c20f7a6a28db3ca3d52ec23408a678a8',
            des: '',
          },
          {
            img: 'http://qimgs.qunarzz.com/dmf_ad_peri.NEWS_INFO.prod/56558d2243759efd08c6ac8bd3d36184.png',
            title: '2022中国泰州梅兰芳艺术节开幕',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=64d4a9b4d6d91aecb0eb8adacac35dad',
            des: '11月16日晚，2022中国泰州梅兰芳艺术节开幕式暨“百梅争艳”戏曲精品汇演在泰州大剧院举行。市委书记朱立凡宣布梅兰芳艺术节开幕，市委副书记、市长万闻华致辞，并与省文化和旅游厅党组书记、厅长杨志纯，市人大常委会主任张余松，市政协主席卢佩民，北京梅兰芳纪念馆副馆长张俊苹共同启动开幕装置。市委常委、宣传部部长，副市长刘霞主持。',
          },
          {
            img: 'http://qimgs.qunarzz.com/dmf_ad_peri.NEWS_INFO.prod/2cfe8663800c4c44534be11eee5586bc.jpg',
            title: '2022“寻味泰州”水城蟹乡没事旅游季暨靖江美食推广周在沪启动',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=43ef4c9f3a7a8b7531b963d3380595d4',
            des: '11月14日晚，2022“寻味泰州”水城蟹乡美食旅游季开幕式暨靖江美食（上海）交流推广周活动在上海浦江游轮“水晶公主号”上拉开帷幕。活动以“泰州味道 ‘靖’享美食”为主题，全方位展示泰州美食文化的魅力。',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-1.jpg',
            title: '2022中国泰州梅兰芳艺术节16日开幕',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=0921abfd4368afa90a94075c9ddea66a',
            des: '中国泰州梅兰芳艺术节筹备工作会议举行。市委常委、宣传部部长，副市长刘霞出席会议并讲话。',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-2.jpg',
            title: '金秋来泰州，这里风轻云淡秋意浓',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=96d2d560f102cc7e7190cbd709166294',
            des: '秋游国家5A级风景区江苏溱湖湿地公园，这里湖面旷远、明媚宛如一块翡翠镶嵌于大地，泛舟湖上，闲看云卷云舒，静享天高气爽，放眼远眺，金黄的树木层层叠叠、错落有致，蔚蓝的天、洁白的云、碧绿的水，还有麋鹿齐奔的壮观景象，让人身心亢奋这里的每一时、每一刻，都是流动的秋日大片。暮色降临，一切归于宁静。',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-3.jpg',
            title: '来泰州这里赏菊，不要门票',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=539f0b4f02b906941c8752b90ea65c5c',
            des: '秋风起，菊花香金秋时节又到一年赏菊花最佳时在泰州兴化市大营镇355亩金丝皇菊、白香菊。迎着秋阳盛情绽放金黄色的花蕊，在雪白的花瓣映衬下黄色尽显高贵，白色尽显无暇。大营镇洋子村农民采摘白香菊走在气味芬芳的花丛中，朵朵金丝皇菊在向你展示独有的高贵',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-4.jpg',
            title: '秋季，漫游泰州，看多彩世界，享美好时光',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=d681e3b18b0ad7afae929a23c0889657',
            des: '在这秋季的最后一个节气，泰州气温宜人，明媚的阳光，照在身上，脸上，大地上，暖烘烘的，给人岁月静好的舒服感。',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-5.jpg',
            title: '第五篇标题：这条“巨龙”网红打卡地，点亮泰州夜生活',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=38617b03a7b014f4f5f316b45f6bcfb1',
            des: '在泰州海陵区新通扬运河边有一处让市民游客近水更亲水的生态园，每天都有很多市民到此休闲、赏景 已成为附近市民热门打卡地此生态园名为泰州百舸生态园。',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-6.jpg',
            title: '打卡泰州靖江 | 刚刚公布，这里全省第一',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=a41a3ba43f96a90228f71042b17701d6',
            des: '仲秋期间是一年中最舒服的时期之一天气不热也不冷也是最适合走出家门的时侯望向仲秋的天宽阔 、舒畅、一碧如洗蓝的使人心醉几朵轻柔的“雪白棉花”飘在空中调皮地变换着各种姿态邀请你一起共享美好时季！这里就是泰州靖江。',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-7.jpg',
            title: '到泰州这个古镇，体验江南小镇的悠闲',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=a55973f878bb51f8074179376370c129',
            des: '在每个人的心中也许都会有一个古镇情怀流水江南，烟笼人家……在泰州也有一个古镇能让你远离城喧体验到江南小镇的悠闲走到泰州海陵区苏陈镇老街转转相传苏陈镇因清朝"苏""陈"二姓首居于此而得名这里还有好玩、好吃的。',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-8.jpg',
            title: '泰州这条老街，即将变成环境雅致的“打卡地”',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=2ceeddec3b550342609c2c2f4d4c4166',
            des: '在泰州海陵区有一条八字桥街，即将成为氛围古朴、环境雅致的‘打卡地”，以往，夜幕降临时分起，这里就变成了美食天堂麻辣烫、梅花糕臭干子、炸串子……',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-zixun-9.jpg',
            title: '游泰州，赏姜堰夜景 | 这里城美、水美、夜景更美',
            link: 'https://adqunar.qunar.com/travelnews/#/detail?sign=0081a32e544b5eacab3e314d2348c1cc',
            des: '初秋的泰州姜堰，白天，褪去了夏日热浪，晚上，凉爽的习习秋风吹掉你所有的烦恼，晚饭后，走出家门 ，沿着慢行步道，感受城市在落日余晖衬托下的美，让你倍感时光美好。',
          },
        ],
        hotelList: [
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-1.jpg',
            price: '23',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=1263893184&from=ios',
            tit: '泰州凤城河景区',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-2.jpg',
            price: '72',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=586926082&from=android',
            tit: '姜堰溱湖风景区',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-3.jpg',
            price: '44',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=1278940802&from=ios',
            tit: '李中水上森林公园',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-4.jpg',
            price: '7',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=1663841757&from=ios',
            tit: '千垛风景区',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-5.jpg',
            price: '38',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=117862486&from=ios',
            tit: '口岸雕花楼景区（柴墟古镇）',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-6.jpg',
            price: '48',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=3110724439&from=ios',
            tit: '泰州凤城河日涉园',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-7.jpg',
            price: '31',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=679893055&from=ios',
            tit: '泰州凤城河桃园景区',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-8.jpg',
            price: '31',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=4279958335&from=ios',
            tit: '泰州凤城河望海楼景区',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-9.jpg',
            price: '29',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=1791810278&from=ios',
            tit: '花栖云里',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-10.jpg',
            price: '31',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=3268751051&from=android',
            tit: '溱潼古镇',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-11.jpg',
            price: '137',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=3364568518&from=ios',
            tit: '爱情海欢乐田园',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-sight-12.jpg',
            price: '66',
            link: 'http://touch.piao.qunar.com/touch/detail.htm?id=130183773&from=ios',
            tit: '天德湖温泉',
          },
        ],
        hotelList2: [
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-1.jpg',
            price: '357',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_2678&type=0&checkInDate=2022-12-30&checkOutDate=2022-12-31',
            tit: '泰州富力万达嘉华酒店',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-2.jpg',
            price: '390',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_2850&type=0&checkInDate=2022-12-30&checkOutDate=2022-12-31',
            tit: '泰州国际金陵大酒店',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-3.jpg',
            price: '268',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_5531&type=0&checkInDate=2022-12-30&checkOutDate=2022-12-31',
            tit: '泰州皇廷国际大酒店',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-4.jpg',
            price: '328',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_3998&type=0&checkInDate=2022-11-29&checkOutDate=2022-11-30',
            tit: '泰州世茂茂御酒店',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-5.jpg',
            price: '389',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_5817&type=0&checkInDate=2022-12-30&checkOutDate=2022-12-31',
            tit: '稻河云舍民宿',
          },
          {
            img: 'https://himg1.qunarzz.com/imgs/202204/04/C.HzyP-PNJ_5wd_GY4Nexact.jpg_c_1280x704x70_.jpg?qtag=qxc',
            price: '272',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_2046&type=0&checkInDate=2022-12-30&checkOutDate=2022-12-31',
            tit: '泰州宾馆',
          },
          {
            img: 'https://himg1.qunarzz.com/imgs/202204/02/C.CrUuksm0JLYtRMxZmexact.jpg_c_1280x704x70_.jpg?qtag=qxc',
            price: '219',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_2056&type=0',
            tit: '泰州美丽华大酒店',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-8.jpg',
            price: '182',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_2335&type=0&checkInDate=2022-12-30&checkOutDate=2022-12-31',
            tit: '泰州黄河大酒店',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-9.jpg',
            price: '290',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_5052&type=0&checkInDate=2022-12-30&checkOutDate=2022-12-31',
            tit: '泰州柳园亚朵酒店',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-10.jpg',
            price: '281',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_4544&type=0&checkInDate=2022-12-20&checkOutDate=2022-12-21',
            tit: '泰州日航酒店',
          },
          {
            img: 'https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-hotel-11.jpg',
            price: '276',
            link: 'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=taizhou_jiangsu_5373&type=0&checkInDate=2022-12-30&checkOutDate=2022-12-31',
            tit: '泰州中国医药城智选假日酒店',
          },
        ],
      },
      wanghong: {},
      tabs: ['主题玩法', '网红打卡', '热门资讯', '旅行商城'],
      tabs2: [
        '特色美食游',
        '景区景点',
        '人文历史',
        '古镇老街',
        '绝美乡村',
        '酒店民宿',
        '非遗传承',
      ],
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.homePage = to.query.tab || 0;
    console.log(this.homePage);
    // 用于相同路由组件的的参数更新
    next();
  },
  created() {
    query('taizhou').then((res) => {
      console.log(res);
      // this.json = res;
    });
    this.homePage = this.$route.query.tab || 0;
    // wanghong();
    let _wanghong = {};
    for (let i = 0; i < 8; i++) {
      _wanghong[i] = [];
    }
    // this.mappingWanghong(mapping1, _wanghong, 0);
    // this.mappingWanghong(mapping2, _wanghong, 1);
    // this.mappingWanghong(mapping3, _wanghong, 2);
    // this.mappingWanghong(mapping4, _wanghong, 3);
    // this.mappingWanghong(mapping5, _wanghong, 4);
    // this.mappingWanghong(mapping6, _wanghong, 5);
    // this.mappingWanghong(mapping7, _wanghong, 6);
    // console.log(JSON.stringify(_wanghong), 1093);
    this.wanghong = {
      0: [
        {
          title: '泰州早茶',
          imgs: [
            // 'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-1-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-1-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-1-3.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-1-4.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-1-5.jpg',
          ],
          content:
            '泰州早茶，传统归纳为“一茶三点一面”，一茶就是一杯茶和一份烫干丝，一份烫干丝叫一个茶头；三点就是说三种泰州的著名早点，即包子、蒸饺、烧卖；一面就是鱼汤面。<br/>吃早茶大致分为五道：第一道喝茶水；第二道应时小菜（浇头）；第三道烫干丝；第四道吃点心；第五道鱼汤面。',
        },
        {
          title: '蟹黄汤包',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-2-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-2-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-2-3.jpg',
          ],
          content:
            '靖江蟹黄汤包“汤清而不腻、稠而不油、味道鲜美”。蒸熟的汤包雪白晶莹,皮薄如纸,几近透明,稍一动弹,便可看见里面的汤汁在轻轻晃动,使人感到一种吹弹欲破柔的柔嫩。吃蟹黄汤包有口诀，叫作“轻轻提、慢慢移、先开窗、后吸汤,最后吃皮”。<br/>在吃蟹黄汤包要轻轻地用筷子把蟹黄拨到碟子一边，再轻轻地用嘴在薄如绸纸的包子皮上吮开一个小口，然后再吮吸里面的鲜美的汤汁，里面那透入骨髓的鲜香之味，让你有醍醐灌顶的快感。',
        },
        {
          title: '溱湖八鲜',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-3-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-3-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-3-3.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-3-4.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-3-5.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-3-6.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-3-7.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-3-8.jpg',
          ],
          content:
            "溱湖水域宽阔，水质清淳，水草丰茂，所繁育生长的水生动植物肉质细嫩，味道鲜美，营养丰富。由溱湖簖蟹、溱湖青虾、溱湖甲鱼、溱湖银鱼、溱湖四喜、溱湖螺贝、溱湖水禽、溱湖水蔬总称之为'溱湖八鲜'。来古镇溱潼，尝溱湖八鲜，品溱湖水啤酒，将使人流连忘返。",
        },
        {
          title: '祁巷八大碗',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-4-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-4-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-4-3.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-4-4.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-4-5.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-4-6.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-4-7.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-4-8.jpg',
          ],
          content:
            '祁巷八大碗，伴随着祁家巷的历史，已有数百年之久。包括了铁锅红烧肉，祁巷草鸡汤，全富肚心肺汤，红烧肥肠，红烧卤水老豆腐，清炖猪爪，红烧菊花鱼，红烧散养鹅、黄鳝猪尾等。<br/>由“江苏名厨”烧制，取材于祁巷村的姜曲海黑肉猪、农家纯草肉猪、小南湖草鸡、贵妃鸡等；由祁巷“五坊”自制的脱脂肉渣、纯豆油、菜油、花生油、麻油、卤水豆腐等等。',
        },
        {
          title: '溱湖簖蟹',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-5-1.jpg',
          ],
          content:
            '溱湖簖蟹，江苏省泰州市姜堰区特产，中国国家地理标志产品。<br/>溱湖簖蟹除具有“青背、白肚、金爪、黄毛”等优质河蟹形态，还具有“体健、色亮、腿长、爪尖”的独特特征，即溱湖簖蟹个体饱满，翻身迅疾，膘肥体壮，力量感强；体表光洁、色泽明亮，头胸甲疣状突起明显，“H”字型花纹清晰；步足硕长，足趾锐利呈弯月状。熟制后，蟹黄呈橙金色，黄中带红；蟹膏呈凝脂状，细腻绵密；蟹香浓郁，鲜美微甜，肉质韧滑。 ',
        },
        {
          title: '泰州三麻',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-6-1.jpg',
          ],
          content:
            '泰州三麻是江苏泰州最具代表性的传统名产。三麻指的是麻油、麻糕、麻饼三样东西的合称。“寿星”牌麻油，不仅质纯、香浓、味醇，而且对延缓皮肤衰老和烫（烧）伤后的皮肤再生有奇效。泰州生产麻糕历史悠久，尤其是“嵌桃麻糕”，素享盛誉。双色麻饼始创于清同治年间，兼甜、咸两味，色泽金黄，质地酥脆，回味无穷。',
        },
        {
          title: '靖江肉脯',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-7-1.jpg',
          ],
          content:
            '靖江猪肉脯是江苏省泰州市靖江市的一道传统名吃，属于苏菜系，该菜品以猪腿肉为主要食材，菜品色泽棕红，光泽美观，口味香甜，食而不腻，成品为片型，长12厘米，宽8厘米，每千克60片左右。',
        },
        {
          title: '黄桥烧饼',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-8-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-8-2.jpg',
          ],
          content:
            '黄桥烧饼是江苏省泰兴市地方传统小吃，流传于江淮一带，得名于1940年10月那场著名的战役“黄桥决战”，战役打响后，泰兴黄桥镇当地群众冒着敌人的炮火把烧饼送到前线阵地，谱写了一曲军爱民、民拥军的壮丽凯歌。<br/>泰兴黄桥烧饼制作的主要原料有面粉，猪油，花生油，芝麻。所用的面粉必须是中筋，强筋和弱筋却不宜制作，所用芝麻必须去皮，去皮的芝麻不得改变它的色泽与形状，一般有咸甜两种口味，讲究的做法是以上等肉松作为馅料。<br/>泰兴黄桥烧饼色泽金黄，外观美观，香酥可口，不油不腻，适合各地消费者的口味。2003年荣获“中华民族小吃”的称号，2004年获“江苏食品博览会金奖”。2005年被评为泰兴市名牌产品，是江苏特色小吃之一。<br/>泰兴黄桥烧饼是中华名小吃、中国地理标志产品，曾被选入开国大典国宴，先后荣获“天下第一饼”“中华第一饼”等称号。',
        },
        {
          title: '宣堡小馄饨',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-9-1.jpg',
          ],
          content:
            '宣堡小馄饨是江苏泰兴市传统名小吃，以产于泰兴市内宣堡镇而得名，形成已有近百年的历史。宣堡小馄饨从大馄饨（江苏地区又称扁食）发展而来，以皮薄、汤鲜、味美著称。',
        },
        {
          title: '季市茵糕',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-a-10-1.jpg',
          ],
          content:
            '季市茵糕是一种米糕，蒸制时用荷叶垫底，米糕中再融入桂花的香味，趁热吃非常香甜可口。也是靖江名小吃的之一。',
        },
      ],
      1: [
        {
          title: '凤城河风景区',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-1-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-1-2.jpg',
          ],
          content:
            '凤城河风景区位于江苏省泰州市城区中心，国家AAAA级旅游景区，融自然景观和人文特色于一体，吸引着来自世界各地的旅游爱好者前来旅游观光。<br/>风景区四面环水，因水成趣，将江南水乡的特色展现的淋漓尽致。凤城河畔，“江淮第一楼”望海楼与其特有的戏曲更显城市的文化底蕴。景区以望海楼为中心，四面辐射，桃园、老街交相呼应。望海楼始建于宋代，无数文人骚客为其留下了珍贵的墨宝。<br/>泛舟水上，听一曲婉转的戏曲，感受这座古城带来的心灵的放松与洗涤，领略水城的风姿与魅力！依傍凤城河，以水为脉，以人为魂，集中而又完整地体现全国不多见的一种都市水韵，彰显了泰州悠久的历史文脉。',
        },
        {
          title: '溱湖国家湿地公园',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-2-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-2-2.jpg',
          ],
          content:
            '江苏姜堰溱湖国家湿地公园是国家AAAAA级旅游景区，系由原国家林业局批准设立的全国第二家、江苏省首家国家级湿地公园。湿地公园位于江苏省泰州市姜堰区境内，地处全国著名三大洼地之一的里下河地区，规划面积为806.9公顷，湿地面积588.6公顷，湿地率72.9%，湿地分为湖泊湿地、河流湿地、沼泽湿地等3类，永久性淡水湖泊、永久性河流、草本沼泽等3型。共划分为湿地保育区、湿地恢复区和合理利用区三大功能分区。',
        },
        {
          title: '兴化千垛景区',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-3-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-3-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-3-3.jpg',
          ],
          content:
            '兴化千垛景区，又称兴化千岛菜花风景区。是全球重要农业文化遗产，江苏省四星级乡村旅游点。千垛景区以“垛田”特色地貌享誉全球。<br/>每年清明时节，千垛景区四面环水的“垛田”上长满了金黄色的油菜花。一幅“油菜花开金满地”的壮阔美景，吸引了众多前来观光的游客。“河有万湾多碧水，田无一垛不黄花”正是兴化垛田菜花的真实写照。如今，千垛景区荷塘绿意更胜，更有另一番浪漫光景。春去秋来，在这千垛田间，见万寿菊花，黄叶纷飞，妍丽雍容，在重阳雨后，正值菊黄蟹肥时，看万花黄透，品水乡河蟹，真可谓美不胜收。 ',
        },
        {
          title: '李中水上森林景区',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-4-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-4-2.jpg',
          ],
          content:
            '李中水上森林是里下河地区规模最大的人工湿地森林生态系统，位于李中镇兴沙公路舜生桥附近。<br/>2014年5月，全国旅游景区质量等级评定委员会正式批准兴化市李中水上森林景区为国家4A级旅游景区，这是兴化首个国家4A级景区。',
        },
        {
          title: '秋雪湖风景区',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-5-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-5-2.jpg',
          ],
          content:
            '秋雪湖风景区位于泰州城区东北部、江苏省现代农业综合开发示范区内，规划总面积38.6平方公里。风景区地处里下河平原的南缘，地势低平，水网稠密，湖荡相连，生态原始，湿地风光独特，可谓是水的世界、苇的海洋、林的天地、鸟的天堂。',
        },
        {
          title: '泰州桃园',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-6-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-6-2.jpg',
          ],
          content:
            '泰州凤城河风景区，位于南城河外侧东岸，东邻泰州老街，西与望海楼隔水相望，北与梅兰芳纪念馆一路之隔。园内核心景点，为复建的明清建筑风格陈庵。庵堂前后三进，部分两层架构，西侧建有小花园，配以仿明清家具，再现清代戏曲家孔尚任出仕泰州治水期间寓居家庵创作《桃花扇》书稿的场景。二零零六年五月，泰州市启动桃园景区工程。二零零七年元旦期间免费试开放。二零零八年五月一日正式开放，为泰州城市八景之一。景区观赏桃主要品种来源于中国农业科学院桃研究所，共有三千六百多株、一百一十六个品种，在国内以观赏类桃花为主题的公园中，品种最多。从树型上可分为矮化型、乔化型、龙柱型及垂枝型；从花色上可分为白色、粉色、红色及杂色；从花型上可分为单瓣型、复瓣型、重瓣型、菊花型、铃型。这里的重瓣型花果两用的满天红桃树，花朵有多层花瓣，数量多达二三十瓣，具有很高的观赏价值，又有结果的功能，较为罕见。景区均衡配植早、中、晚期桃树，阳春三月，桃花次第开放，竞相争艳，吸引游人驻足观赏。二零零九年三月二十日至四月十五日，泰州桃园举办首届桃花节。赏花时间可从三月中旬持续到四月下旬，花期时间跨度较长，约四十天。',
        },
        {
          title: '乔园',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-7-1.jpg',
          ],
          content:
            '乔园位于江苏省泰州市老城区，西接海陵北路（旧称八字桥直街），南倚八字桥东街。现存园林面积不大，但构思巧妙、历史悠久，有“淮左第一园”之称，现为江苏省省级文物保护单位。',
        },
        {
          title: '柳园',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-8-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-8-2.jpg',
          ],
          content:
            '泰州柳园位于泰州市区口泰路23号东城河南岸打渔湾，为古“海陵八景”之一的“南濠渔唱”园外柳堤环绕；园内柳树、竹林、桂花林、广玉兰林相互渗透，曲径通幽、古韵犹存，景色别致。现已恢复打鱼湾景观，柳敬亭纪念堂等。',
        },
        {
          title: '靖江牧城公园',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-9-1.jpg',
          ],
          content:
            '牧城公园位于江苏省靖江市滨江新城东侧，东接新港城，南临浩瀚长江，北倚沿江高等级公路，占地约4000亩，其中景观湖面积约600亩。滨江生态园通过园林绿化营造森林生态景观，挖湖造景，拓展亲水空间，体现清新自然、返璞归真的特点，突出“绿地、水乡、休闲、宜居”四大要素，形成森林生态、温泉度假、滨江湿地、亲水湖滨、田园野趣、特色文化、商业美食等功能区，为广大市民提供旅游观光休闲的好去处。',
        },
        {
          title: 'G12欢乐谷',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-10-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-10-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-b-10-3.jpg',
          ],
          content:
            '“G12农乐谷”项目暨现代农业创新示范园是一个围绕铭坤村地形现状统筹规划的，集一、二、三产融合发展的新型生态农业园区。项目位于马桥镇铭坤村，占地约1664亩土地，一期项目建设约400亩，投资约3500万元。打造“乡村版迪士尼”（12生肖主题乐园）和“微缩版果蔬联合国”（12种果蔬智慧种植休验）两大核心项目。合理利用生态与文脉底蕴，塑造春之花、夏之荫、秋之果、冬之韵的现代农业园区风貌。',
        },
      ],
      2: [
        {
          title: '泰州博物馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-1-1.jpg',
          ],
          content:
            '泰州文化中心建筑之一。地处泰州主城区中轴线。位于泰州规划展示馆南侧、泰州图书馆新馆北侧。南北方向最长一百二十四米，东西方向最长七十五米。总建筑面积约二点二万平方米，总投资总额一点五亿元。泰州市博物馆原址位于海陵路，二零零六年整体搬迁到原泰州广电局大院，面积约三千平方米。受场地等因素限制，泰州市博物馆旧馆已经四年多没有对外展览。新馆预计二零一零年底完成主体封顶，未来将是泰州市文物、珍宝展示的主要场所。',
        },
        {
          title: '梅兰芳纪念馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-2-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-2-2.jpg',
          ],
          content:
            '梅兰芳纪念馆在环城河风景区的凤凰墩上，三面环水，绿树成荫，风景雅致。分梅亭区、史料陈列区、兰圃区等三个景区。梅亭由著名古典园林专家陈从周指导设计，梁枋上雕有《霸王别姬》、《贵妃醉酒》等五出梅派名剧图案，栩栩如生。梅兰芳大型全身汉白玉塑像，为全国著名雕塑大师刘开渠晚年之作。史料陈列馆由明、清建筑移建而成，既有园林风貌，又保留了泰州的古建筑特色；7个展厅陈列了梅兰芳生前的大量活动照片和实物。坐落在市区风景秀丽的东城河畔，是一座以移建明、清建筑为主体的园林式名人纪念馆。馆名由李先念同志亲笔题写。馆区三面环水，由园林区与史料陈列区组成。<br/>梅兰芳纪念馆先后被列为江苏省爱国主义教育基地，江苏省学校教育德育基地，江苏省创建文明旅游景区示范点和泰州市爱国主义教育基地，文明单位等。',
        },
        {
          title: '海纪馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-3-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-3-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-3-3.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-3-4.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-3-5.jpg',
          ],
          content:
            '中国人民解放军海军诞生地纪念馆，位于江苏省泰州市高港区白马镇。这里是"全国文物保护单位"，"全国爱国主义教育示范基地""全国红色旅游经典景区""国家全民国防教育基地""全国科普教育基地""国家航海科普教育基地""江苏省全民国防教育基地"，中国人民解放军海军东海舰队"战斗精神教育基地"。1998年，时任中共中央军委主席的江泽民亲笔题名的"中国人民解放军海军诞生地纪念馆"。',
        },
        {
          title: '兴化郑板桥·范仲淹纪念馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-4-2.jpg',
          ],
          content:
            '由“三绝奇才——郑板桥”、“楚水流长——兴化简史陈列”、“范仲淹纪念馆”等6个固定陈列展览展示区和2个临时展厅、江苏省文保单位李园、兴化县署、四牌楼、城内东大街古建筑群及四牌楼文化广场组成。',
        },
        {
          title: '海军舰艇文化园',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-5-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-5-2.jpg',
          ],
          content:
            '泰州市高港区在泰州长江大桥北桥头堡区域内永久性规划建设海军文化公园，旨在弘扬海军文化，加强青少年国防教育。这既是该区滨江新城沿江绿地内的一个主要功能分区，也是白马庙海军诞生地纪念馆向海军舰艇文化延伸的一个重要拓展分区，将与海军诞生地白马庙原址和海军纪念馆遥相呼应、互为依托，形成"三位一体"的海军文化展示平台和海军主题教育基地。',
        },
        {
          title: '杨根思纪念馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-6-1.jpg',
          ],
          content:
            '杨根思烈士陵园整体建筑方案是1978年在"杨根思烈士事迹陈列馆"的基础上由建筑界泰斗杨廷宝和东南大学教授齐康主持设计的。陵园占地38666.26平方米，其中建筑物面积1760.33平方米。建筑物为古典式大屋顶结构，呈阶梯式拾级而高。陵园陈列室分南北两厅，以图片资料陈列为主，其中三级文物12件(套)，一般文物17件(套)。',
        },
        {
          title: '中共江浙区泰兴独立支部纪念馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-7-1.jpg',
          ],
          content:
            '泰州中共江浙区泰兴独立支部纪念馆中共江浙区泰兴独立支部诞生地。由泰兴市人民政府于2001年扩建后，2002年7月1日重新开放。现占地20亩，建筑面积1300平方米。原红十四军大队长、国防部长张爱萍上将为纪念馆题写了馆名。建馆20多年来，始终坚持正确的办馆方向，在征集、收藏，管护革命文物，举办陈列展览，研究宣传独支历史，对广大人民群众、党员干部，特别是青少年学生进行爱国主义、社会主义革命传统教育中发挥了应有的职能作用。',
        },
        {
          title: '苏北党校旧址',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-8-1.jpg',
          ],
          content:
            '苏北党校旧址位于海陵区苏陈镇，占地面积6195平方米。1949年4月15日，中共苏北区委员会在泰州西郊塘头（今属江都区郭村镇）成立，4月21日，苏北行政公署在泰州西郊张家坝（今属海陵区九龙镇）成立。为巩固老区、建设新区，提升党员干部队伍整体素质，同年4月，苏北区委党校在泰州东郊苏陈庄（今海陵区苏陈镇）成立。',
        },
        {
          title: '江苏盐税博物馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-9-1.jpg',
          ],
          content:
            '江苏盐税博物馆坐落于泰州古城河边，是历史上泰坝监掣署所在地。而泰州，是一座因盐而生、因税而兴的历史文化古城，素以“富有红粟、鹾盐之利”名，是我国重要的盐税文化发源地之一。<br/>江苏盐税博物馆中，一枚刻有篆书“泰州西溪镇茶盐酒税王记”阳文字样的税务铜印，可以说是博物馆的镇馆之宝，据考证，该铜印为北宋庆历七年（1047年）铸造。此税印的发现为研究我国古代税赋历史，尤其是研究泰州地区的盐税历史提供了重要的实物佐证。涉及盐税征收、盐官考核、盐业产销、盐政管理、淮盐运道、辑盐查私、两淮盐引大案等多个方面。',
        },
        {
          title: '崇儒祠（泰州学派）',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-10-1.jpg',
          ],
          content:
            '崇儒祠，祀泰州学派创始人王艮。万历以后多次修葺、扩建，清嘉庆再修。原有东中西三条轴线，中部为祠堂4进，东西部各有3进附属用房，后有园圃。解放后用作民居与与厂房。1986年迁出占用之人及单位。决定将崇儒祠建成王艮及泰州学派纪念馆，并对崇儒祠进行大修，恢复中部原貌，中部现有建筑4进。',
        },
        {
          title: '泰和堂国医馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-11-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-11-2.jpg',
          ],
          content:
            '改革开放后，“泰和堂” 进入北京，并于1996年先后成立针对中医基本理论研究的机构“北京泰一和中医药研究所”。针对中药研发与重大疾病的预防治疗，成立了“三生万医药科技有限公司”。',
        },
        {
          title: '学政试院',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-12-1.jpg',
          ],
          content:
            '学政试院原先是明朝都察院，清康熙以后成为扬州府治八个县市考秀才的地方。',
        },
        {
          title: '施耐庵文化园',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-13-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-13-2.jpg',
          ],
          content:
            '施耐庵文化园中最核心的部分就是施耐庵陵园，施耐庵是元末明初著名的小说家，最为大众所熟知的就是四大小说之一的水浒传，生于泰州兴化的施耐庵先生，陵园就位于兴化新垛镇施家桥，墓始建于明初。',
        },
        {
          title: '评书评话博物馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-14-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-c-14-2.jpg',
          ],
          content:
            '中国评书评话博物馆暨柳敬亭纪念馆是中国评书评话展示、研究、培训以及比赛和演出基地。位于泰州海陵区打鱼湾、原柳敬亭公园内。该馆为国内唯一评书评话博物馆、泰州首个国字号博物馆。',
        },
      ],
      3: [
        {
          title: '泰州老街',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-1-1.jpg',
          ],
          content:
            '泰州老街是位于江苏省泰州市海陵区的一个景区， 是国家AAA级旅游景区。泰州老街并非真正意义上的老街，包括与此毗邻的桃园的地块，原都是东郊鲍坝村的一片农田和村民住宅地。随着东城河风景区的规划和开发，泰州老街才于2007年正式动工，历经两年时间形成了现在的规模。',
        },
        {
          title: '稻河古街区',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-2-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-2-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-2-3.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-2-4.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-2-5.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-2-6.jpg',
          ],
          content:
            '稻河古街区建设项目总投资20亿元，共分三期建设。一期工程主要包括建设科学发展观展示馆和涵西街三处文保单位修缮，二、三期工程主要包括对五巷、涵西街等16.8公顷历史文化遗存进行保护与利用。',
        },
        {
          title: '溱潼古镇',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-3-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-3-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-3-3.jpg',
          ],
          content:
            '泰州溱潼古镇位于江苏省泰州市姜堰区溱潼镇，该镇四面环水，环境优美，为鱼米之乡。',
        },
        {
          title: '泰州华侨城',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-4-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-4-2.jpg',
          ],
          content:
            '2010年4月28日，泰州华侨城在姜堰区溱潼镇开业。这是“中国旅游第一品牌”的华侨城集团在第二轮全国布局的点睛之作，泰州华侨城的发力点则是打造“中国湿地生态温泉第一城”。泰州华侨城，在苏中大地，犹如一幅天地之间的水墨画，徐徐铺延在溱湖岸边。',
        },
        {
          title: '口岸雕花楼',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-5-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-5-2.jpg',
          ],
          content:
            '雕花楼是以木雕及砖雕为其特色的建筑楼馆。古雕花楼在江苏境内只存三处，一处在苏州金庭镇（西山），一处在苏州东山镇，一处在泰州市高港区。苏州西山雕花楼位于苏州太湖西山堂里古村，西山雕花楼的原名是“仁本堂”，取自“以仁为本、礼为教本”的意思。高港雕花楼位于高港区向阳支路，坐西面东，由前后两幢各五间的二层主楼和左右各三间的厢楼组成，是一座四方楼。苏州吴县雕花楼为江苏省文物保护单位。是一座具有南方风格的民间住宅，在木雕、砖雕、石雕、建筑构思、造园艺术上集中反映了吴县香山匠人的智慧和才能，艺术价值颇高。',
        },
        {
          title: '姜堰曲江楼',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-6-1.jpg',
          ],
          content:
            '曲江楼位于泰州市姜堰区南大街219号，以其位于古运盐河拐弯处，故名曲江楼。1940年夏秋，新四军抗日东进。9月，新四军苏中指挥部驻曲江楼，总指挥陈毅下榻于楼上，运筹帷幄，为我军决战黄桥前打赢了政治仗，进而取得了“黄桥决战”的胜利。',
        },
        {
          title: '黄桥古镇',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-7-1.jpg',
          ],
          content:
            '黄桥古镇建于北宋神宗元丰年间，是一座具有悠久历史的千年古镇和具有丰厚底蕴的文化名镇。',
        },
        {
          title: '兴化银北门',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-8-1.jpg',
          ],
          content:
            '兴化银北门位于泰州兴化老城区北首，曾是明清最繁华的商业街。2016年，兴化银北门被江苏省人民政府公布为省级历史文化街区。目前街区包含1处省级和4处市#级文物保护单位、6处登记不可移动文物和5处历史建筑。为进一步传承美食文化，彰显街区特色，兴化市决定打造银北门“品蟹一条街”，将银北门历史文化街区，嵌入了“兴化大闸蟹”元素',
        },
        {
          title: '兴化八字桥文旅休闲街区',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-9-1.jpg',
          ],
          content:
            '八字桥文旅休闲街区地处兴化市老城区中心位置，街区串联名人、小说、国象等地方文化，涵盖兴化市博物馆、郑板桥·范仲淹纪念馆、兴化市国象博物馆等景点，李园、四牌楼、八字桥等12处文保单位，以及八字桥文化广场和商业街区两大文旅商集结区，突出“板桥竹”“状元宰相”元素的夜间景观氛围。',
        },
        {
          title: '金东门历史街区',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-d-10-1.jpg',
          ],
          content:
            '金东门历史文化街区位于素有“金东门”之称的兴化城东部地区，是一个由明清古民居群组成的街区，历史上店铺林立，商贾云集，保存着大批完整的明清民居建筑群和诸多历史古迹。<br/>先后修复东岳庙、上池斋药店、赵海仙洋楼、家舒巷古民居建筑群、郑板桥故居等文保单位，修缮古城墙、赵状元坊等，恢复了原汁原味的古城传统景观风貌。',
        },
        {
          title: '沙沟古镇',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221121-shijianchen-tai-5sm.jpg',
          ],
          content:
            '是一座被时间遗忘的古镇，早在公元前206年，此地就有射阳村之说，后又被称为沙溪、石梁。自古以来，沙沟人文荟萃，据史料记载沙沟科举时代的进士举人达120多人，也出现过很多的名人学贤，如明朝福建右布政使万石梁、清康熙年间的昭勇将军姜望龄、清著名诗人刘沁区、国大代表赵阎生、国学大师李详等等。',
        },
      ],
      4: [
        {
          title: '姜堰区三水街道小杨村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221121-shijianchen-tai-6sm.jpg',
          ],
          content:
            '泰州溱湖绿洲度假村，位于溱湖湿地公园向南约2公里，坐落在风景如画的水、田、园、林、花和草中。这里的河网交织，芳草如茵，绿树环抱，空气清新，环境优美；白天帆影翩翩，夜晚渔火点点，构成水乡独特的自然风光和民俗风情。',
        },
        {
          title: '泰兴市黄桥镇祁巷村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221130-shijianchen-tai-11.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-e-2-2.jpg',
          ],
          content:
            '祁巷村，中国历史文化名镇——黄桥镇南首，东临分界，南邻珊瑚。2001年，由东小湖、丁庄、周堡、祁巷四个自然村合并组建而成。辖25个村民小组，现有党员112人，村民1498户，共5516人，耕地面积6341亩，养殖水面600亩。<br/>从2011年起，先后获得全国文明村、“中国美丽乡村”、全国“一村一品”专业示范村、全国巾帼现代农业科技示范基地等全国性荣誉，“江苏省民主法治示范村”、“江苏省现代农业示范村”、“江苏省林业绿化模范村”、“江苏省生态村”、“江苏省社会主义新农村建设先进村”、“江苏省科普示范基地”、“江苏省和谐社区”、“江苏省最美乡村”、“江苏省四星级乡村旅游区”、“江苏省水利风景区”、“江苏省菜篮子基地”等省级荣誉。2019年12月12日，祁巷村入选“2019年中国美丽休闲乡村”名单。',
        },
        {
          title: '兴化市千垛镇东罗村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221130-shijianchen-tai-22.jpg',
          ],
          content:
            '东罗村，隶属于江苏省泰州市兴化市千垛镇。东罗村由原东罗、西罗两个自然村合并而成，共有16个村民小组，684户，2265人口，1189个劳动力，土地面积4011亩，其中耕地面积2239亩，水面1272亩，2011年实现社会总产值13650万元，人均纯收入10650元。<br/>2019年12月25日，国家林业和草原局评价认定千垛镇东罗村为国家森林乡村。   2020年4月，入选首批江苏省传统村落名单。8月26日，入选第二批全国乡村旅游重点村名单。',
        },
        {
          title: '医药高新区（高港区）白马镇陈家村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221130-shijianchen-tai-33.jpg',
            // 'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-e-4-2.jpg',
          ],
          content:
            '陈家村附近有斯里兰格那塔斯瓦米寺、印度乌蒂植物园、金奈、高韦里河、默哈伯利布勒姆古迹群、高港口岸雕花楼等旅游景点，有泰州芋头、泰州麻糕、无影灯笼、泰州小磨麻油、全羊席、米粉干等特产，有兴化传统木船制造技艺、清明节（溱潼会船）、茅山号子等民俗文化。',
        },
        {
          title: '姜堰区溱潼镇湖南村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-e-5-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-e-5-2.jpg',
          ],
          content:
            '湖南村是江苏省泰州市姜堰区溱潼镇下辖的一个村级行政单位，现有28个村民小组，1423户，4536人，2012年全村三业总产值1.5亿元，村集体经济收入270万元，农民人均纯收入13426元。<br/>2019年12月31日，入选第二批国家森林乡村名单。  2020年4月，入选首批江苏省传统村落名单。 ',
        },
        {
          title: '姜堰区溱潼镇河横村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-e-6-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-e-6-2.jpg',
          ],
          content:
            '河横村位于江苏省泰州市姜堰区溱潼镇 ，距离姜堰城区10公里，地处姜堰、兴化、东台三地交界处，紧邻国家AAAAA级溱湖风景区，区域内有宁盐一级公路、宁靖盐高速公路、省级航道姜溱河，地理位置优越，交通十分便利。该村1990年被联合国环境规划署授予生态环境"全球500佳"称号。',
        },
        {
          title: '海陵区城西街道麒麟村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-e-9-1.jpg',
          ],
          content:
            '麒麟村位于泰州市海陵区江洲北路，南接城北物流园区，东接海陵农业生态示范园，麒麟湾生态园位于海陵农业生态示范园内，隶属与城西街道办事处。',
        },
        {
          title: '泰兴市曲霞镇印达村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-e-10-1.jpg',
          ],
          content:
            '印达村位于泰兴市曲霞镇境内，与靖江市接壤。印达村因印达烈士而得名，历史文化底蕴厚重。全村共有14个村民小组，2个自然村庄，644户，2200人，区域面积3339亩，先后被评为第二届江苏最美乡村、江苏最具魅力休闲乡村、江苏省四星级乡村旅游点。',
        },
        {
          title: '徐周村',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221121-shijianchen-tai-9sm.jpg',
          ],
          content:
            '徐周村隶属靖江市马桥镇，位于江平路北侧，属城郊结合区域。2009年4月，原徐周村与铭坤村党组织整合，成立徐周中心村党委。村两委成员13名，大学生村官一名，劳动专干两名。现全村共有24个村民小组，人口2786人，总面积5.8平方公里，耕地面积3120亩。2013年，徐周中心村集体经济收入37万元，村民人均收入1.5万元。全村基础设施完善，组级道路全部硬质化，80%以上的农户使用沼气或秸秆气，建有文化活动中心，拥有便民健身场所。近年来，徐周中心村大力发展一、二、三产业，不断提高土地利用率。在工业方面，经过多年努力，积极招商引资，现有企业18家，形成了以江平路为东西线三产服务业、工业强村的格局。',
        },
      ],
      5: [
        {
          title: '泰州宾馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-1-1.jpg',
          ],
          content:
            '作为江苏省长江以北第一家五星级饭店，拥有“全国百家优秀星级饭店”美誉的泰州宾馆，坐落于景致怡人的东城河畔，毗邻梅兰芳公园，老街、桃园风景区，园林景观，清静幽深。',
        },
        {
          title: '泰州美丽华大酒店',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-2-1.jpg',
          ],
          content:
            '美丽华大酒店地处泰州“未来之星”的新凤凰东路66号，占地近万平方米，主体大楼15层，酒店设计新颖，装饰富丽堂皇，高贵典雅，设施先进，环境优美，是中外宾客之最佳选择。',
        },
        {
          title: '兴华天宝花园大酒店',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-3-1.jpg',
          ],
          content:
            '兴化天宝花园大酒店位于兴化市行政中心区域,处于城市两大交通主动脉之间,毗邻政府机关、金融中心、商业广场、医院、学校、体育馆和高档住宅小区,与汽车站、高速公路出入口相邻',
        },
        {
          title: '靖江国际大酒店',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-4-1.jpg',
          ],
          content:
            '靖江国际大酒店成立于2004年元月，是江苏省靖江市首家四星级商务旅游饭店。酒店地处靖江新、老城区交汇区，位于城市中轴线人民路商业繁华地段，紧邻大润发大型购物中心，距新的靖江行政中心仅5分钟；步行至靖江金融中心、市民广场、步行街、大型超市、电影院只需5分钟，从G2京沪高速靖江出口至酒店3分钟车程，靖江至各机场车程在2个小时内的有上海浦东、虹桥国际机场，南京碌口国际机场；车程在1个小时内的有常州奔牛机场、无锡苏南硕放国际机场、扬州扬泰机场、南通兴东机场；交通极为便利。',
        },
        {
          title: '稻河云舍民宿',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221130-shijianchen-tai-66.jpg',
            'https://source.qunarzz.com/site/images/wns/20221130-shijianchen-tai-55.jpg',
          ],
          content:
            '民宿位于稻河古街的核心地带，去哪都特别方便，像古井博物馆、盐税博物馆、古光孝寺、城隍庙等小景区都在不远处！最主要的是，民宿里有一位特别可爱的小姐姐，声音很暖心，而且很热情！另外，民宿每天都会提供特色早餐和精致的下午茶！',
        },
        {
          title: '东罗耕朵民宿',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221130-shijianchen-tai-44.jpg',
          ],
          content:
            '这个民宿是东罗村村民晏德贵自己建成的。做了多年饭店生意的他，也没有料想到有一天自己会经营民宿，甚至因为这个民宿，越来越多的人来兴化东罗旅游。',
        },
        {
          title: '溱潼民宿',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-7-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-7-2.jpg',
          ],
          content:
            '溱潼古镇听雨轩民宿是一栋仿明清古建的古朴民居，环境清静雅致，内设有一间大床房，可同时容纳2人入住，非常适合情侣度假入住，且房间内设施齐全，',
        },
        {
          title: '天德湖宾馆',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-8-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-8-2.jpg',
          ],
          content:
            '泰州天德湖宾馆以无可比拟的缤纷体验期待您前来探索，现代社会中人们休闲娱乐、旅游度假和经商洽谈的理想之所，为泰州这座历史文化名城倍添异彩。',
        },
        {
          title: '泰州国际金陵大酒店',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-9-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-9-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-9-3.jpg',
          ],
          content:
            '泰州国际金陵大酒店泰州国际金陵大酒店提供的设施和服务确保客人获得舒适的入住体验。 酒店提供免费 Wi-Fi,确保你与家人好友沟通无阻。泰州国际金陵大酒店位于泰州市海陵区海陵南路298号(泰州大剧院旁)',
        },
        {
          title: '泰州富力万达嘉华酒店',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-10-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-10-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-f-10-3.jpg',
          ],
          content:
            '泰州富力万达嘉华酒店拥有248间客房与套房,每间客房均配备温馨舒适的“万达嘉华之床”及“妙梦”助眠系列可供选择,<br/>万达嘉华酒店,原先是希尔顿逸林酒店,在泰州算是比较好的一家五星级大酒店。酒店旁边就是万达广场,餐饮,交通,逛街都很便捷。酒店房间比较大,双标的单人床也比较宽敞,一家三口住绰绰有余。',
        },
      ],
      6: [
        {
          title: '溱潼会船',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-1-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-1-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-1-3.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-1-4.jpg',
          ],
          content:
            '溱潼会船是江苏省泰州市的传统民俗文化活动。四月的姜堰，天蓝水碧，桃红柳绿，麦青花黄，景色宜人。每逢清明时节，在碧波荡漾的溱潼喜鹊湖湖面，都会汇聚成百上千船只，篙子船竹篙如林，划子船轻盈似燕，花船张灯结彩，贡船五彩缤纷。一万多男女选手身着各式民族服装在水上表演、比赛，传承水乡神韵，展示民俗风采。两岸十多万观众欢声如潮，气势磅礴。溱潼会船使喜鹊湖成为欢乐的海洋。凡目睹会船盛况者，无一不为之震撼，无一不为之感动。',
        },
        {
          title: '泰州盆景技艺',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-2-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-2-2.jpg',
          ],
          content:
            '“一是滚弯。分直滚，侧滚，卧滚，垂滚等。枝干滚弯时，吸收书画的意境，前后左右曲折伸展，盘旋而上，弯曲的角度及弯与弯之间的距离富有变化，以达到虬曲飘逸的效果。二是云片。剪扎时将伸展出的枝条在水平方向上做水浪式弯曲，每根枝条的顶端做到“一寸三弯”，犹如绘画中的工笔细描，叶叶平仰而列，成云片状。云片的多与少，视植株大小及树型而定，小片如碗口，大片如缸口，极为平整。整体造型高下匀称，层次分清。',
        },
        {
          title: '板桥道情',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-3-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-3-2.jpg',
          ],
          content:
            '郑板桥创作的《道情》十首，使得道情曲在南方，尤其在江苏淮扬地区风靡一时。它采用的是流行于扬、淮间的两种“淮扬小调”，一为“宫”调式，一为“羽”调式，在本地尤以“宫”调式最为盛行。板桥先生看中了这一为百姓喜闻乐见的民间艺术形式，1725年始作道情，三十七岁时1729年完成了《道情》十首初稿，几经修改，1743年他五十一岁时方付梓，刻者为板桥先生好友司徒文膏，历时十四年，定名《小唱》。板桥先生堪称中国文人将《道情》还其本来面目的第一人。',
        },
        {
          title: '海陵撂石锁',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-4-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-4-2.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-4-3.jpg',
          ],
          content:
            '撂石锁（海陵撂石锁），第五批国家级非物质文化遗产代表性项目之传统体育、游艺与杂技类扩展项目。',
        },
        {
          title: '口岸虎头鞋',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-5-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-5-2.jpg',
          ],
          content:
            '口岸虎头鞋，江苏省泰州市高港区第二批市级非物质文化遗产代表性项目名录传统美术类项目。',
        },
        {
          title: '兴化传统木船',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221121-shijianchen-tai-7sm.jpg',
            // 'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-6-2.jpg',
          ],
          content:
            '兴化木船制造工艺是江苏泰州兴化市的地方传统手工技艺，遗产编号：Ⅶ-23，泰州市兴化市于2006年申报成功。该工艺明朝以制造农用船和内河捕捞渔船为主，到清朝末年，竹泓木船制造已成气候，全镇以周、郑、陈、王、冯、崔、李等几大姓为主，从事纯手工生产农用、渔用、商用木船，并延至现今。',
        },
        {
          title: '姜堰面塑',
          imgs: [
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-7-1.jpg',
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-g-7-2.jpg',
          ],
          content:
            '江苏省省级第四批非物质文化遗产代表性项目名录传统美术类项目。',
        },
      ],
      7: [],
    };
  },
  methods: {
    mappingWanghong(mapping1, _wanghong, current) {
      let map = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
      mapping1.forEach((item, j) => {
        let obj = {
          title: item.label,
          imgs: [],
          content: item.content,
        };
        for (let i = 0; i < item.num; i++) {
          obj.imgs.push(
            'https://source.qunarzz.com/site/images/wns/20221115-shijianchen-' +
              map[current] +
              '-' +
              (j + 1) +
              '-' +
              (i + 1) +
              '.jpg',
          );
        }
        _wanghong[current].push(obj);
      });
    },
    showVideo: showVideo,
    scrollTo() {
      let timer = setTimeout(() => {
        clearTimeout(timer);
        let idList = ['theme', 'daka', 'zixun', 'shop'];
        timer = 0;
        console.log(idList[this.current]);
        window.scrollTo(0, $('#' + idList[this.current]).offset().top);
      }, 300);
    },
    toggle(index) {
      this.current = index;
      this.scrollTo();
    },
    toggle2(index) {
      this.current2 = index;
    },
    jumpToDaka(tab) {
      this.homePage = tab;
      location.href = '/currency/#/taizhou?tab=' + tab;
    },
    showDetail(item) {
      wanghong({
        title: item.title,
        html: item.content,
        type: 'html',
      });
    },
    showLineDetail(item) {
      if (item.detail) {
        wanghong(item.detail);
      } else {
        wanghong({
          title: item.text,
          html: item.html,
          type: 'html',
        });
      }
    },
  },
};
</script>
<style lang='less' scoped='true'>
@font-face {
  font-family: 'fzyt';
  src: url('https://source.qunarzz.com/site/images/wns/fzyt.TTF');
}
@font-face {
  font-family: 'NotoSansCJKscRegular';
  src: url('https://source.qunarzz.com/site/images/wns/NotoSansCJKsc-Regular.otf');
}
.NotoSansCJKscRegular {
  font-family: 'NotoSansCJKscRegular';
}
.taizhou {
  background-color: #ffeda9;
}
.banner {
  height: 612px;
  position: relative;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  overflow: hidden;
  .videobg {
    width: 344px;
    bottom: 20px;
    position: absolute;
    z-index: 2;
    background-color: #d0d29f;
    padding: 10px;
    border-radius: 3px;
    box-sizing: border-box;
    left: 50%;
    margin-left: -172px;
    .play{
      width:40px;
      position: absolute;
      left:50%;
      top:50%;
      transform: translate(-50%,-50%);
    }
    img {
      width: 100%;
      display: block;
      position: static;
    }
  }
}
.banner2 {
  height: 410px;
}
.tabs {
  &:before,
  &:after {
    content: '';
    display: block;
    clear: both;
  }
  width: calc(100% - 30px);
  margin: 0 auto;
  padding-top: 20px;
  .tab {
    height: 30px;
    background-color: #5d8c05;
    color: #fff;
    width: 80px;
    float: left;
    position: relative;
    z-index: 2;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    &.active {
      background-color: #f0df1a;
      color: #5d8c05;
    }
    &:nth-child(2) {
      background-position-x: -89px;
    }
    &:nth-child(3) {
      background-position-x: -178px;
    }
    &:last-child {
      background-position-x: -268px;
      margin-right: 0;
    }
  }
}
.tabs2 {
  &:before,
  &:after {
    content: '';
    display: block;
    clear: both;
  }
  // position: absolute;
  left: 0;
  text-align: left;
  // display: inline-flex;
  .tab {
    height: 27px;
    background-color: #5d8c05;
    width: 80px;
    display: flex;
    float: left;
    position: relative;
    z-index: 2;
    margin-right: 8px;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-bottom: 8px;
    &.active {
      background-color: #f0df1a;
      color: #5d8c05;
    }
    &:nth-child(4) {
      margin-right: 0;
    }
    &:nth-child(5) {
      margin-left: 40px;
    }
  }
}
.tabs2Fluid {
  position: relative;
  width: calc(100% - 30px);
  padding-top: 20px;
  overflow-x: auto;
  margin: 0 auto;
}
.box {
  position: relative;
  // background: url(https://source.qunarzz.com/site/images/wns/20221117-shijianchen-tai-homebg.jpg)
  //   no-repeat;
  // background-size: 100% auto;
}
.boxTit1 {
  width: 100%;
  margin: 22px auto 10px;
  background: url(https://source.qunarzz.com/site/images/wns/20230222-shijianchen-tit.png)
    no-repeat;
  background-size: 100% auto;
  height: 55px;
  font-size: 22px;
  padding-left: 80px;
  padding-top: 5px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  align-items: center;
  font-weight: bold;
  justify-content: center;
}
.boxTit3 {
  width: calc(100% - 60px);
  margin: 36px auto 22px;
}
.boxTit4 {
  width: calc(100% - 60px);
  margin: 94px auto 22px;
}
.boxBg {
  position: relative;
  width: 342px;
  margin: 0 auto;
  min-height: 234px;
  .boxBgImg {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }
}
.lineList {
  position: relative;
  z-index: 2;
  width: calc(100% - 30px);
  margin: 0 auto;
  height: 200px;
  overflow-y: auto;
  top: 20px;
  .lineItem {
    display: flex;
    justify-content: space-between;
    padding-left: 14px;
    padding-right: 14px;
    margin-bottom: 17px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .lineItem-lf {
    img {
      width: 116px;
      height: 76px;
      object-fit: cover;
    }
  }
  .lineItem-rt {
    width: calc(100% - 116px);
    &-txt {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #7d5a12;
      line-height: 17px;
      text-align: left;
      padding-left: 20px;
      box-sizing: border-box;
      position: relative;
      margin-top: 9px;
      &:after {
        content: '';
        display: block;
        width: 130px;
        height: 10px;
        position: absolute;
        border: 1px solid rgba(125, 90, 18, 1);
        border-top: none;
        top: 10px;
        left: 15px;
        opacity: 0.5;
      }
    }
    &-des {
      font-size: 9px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #7d5a12;
      line-height: 12px;
      padding-left: 9px;
      text-align: left;
      margin-top: 12px;
    }
  }
}
.boxBg3 {
  position: relative;
  width: 342px;
  margin: 0 auto;
  height: 234px;
  .boxBgImg3 {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }
}
.newBox {
  width: 344px;
  margin: 0 auto;
  .newBoxChild {
    background: url(https://source.qunarzz.com/site/images/wns/20230222-shijianchen-bg3.png)
      repeat;
    background-size: 100% 100%;
    min-height: 50px;
  }
}
.hotelTit,
.ticketTit {
  height: 40px;
  margin: 0 auto;
  img {
    height: 40px;
  }
}
.hotelTit {
  margin-top: 30px;
}
.videoComp2 {
  width: 352px;
  height: 195px;
  margin: 0 auto;
}
.boxBg2 {
  position: relative;
  width: 342px;
  margin: 0 auto;
  height: 195px;
}
.boxBg4 {
  position: relative;
  width: 342px;
  margin: 0 auto;
  height: 234px;
  .boxBgImg4 {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }
}
.zixunList {
  margin: 0 auto;
  position: relative;
  z-index: 4;
  top: 20px;
  height: 184px;
  overflow-y: auto;
  .zixunItem {
    display: flex;
    align-items: center;
    padding-left: 11px;
    border: 1px solid #baab89;
    border-radius: 7px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
    .zixunItem-lf {
      color: #7d5a12;
      text-align: left;
      width: calc(100% - 118px);
    }
    .zixunItem-tit {
      -webkit-line-clamp: 1;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      padding-right: 22px;
      box-sizing: border-box;
    }
    .zixunItem-des {
      font-size: 9px;
      margin-top: 10px;
    }
    .zixunItem-rt {
      height: 76px;
      img {
        width: 118px;
        height: 76px;
      }
    }
  }
}
.lookMore {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #5E8C06;
  text-decoration: underline;
  margin: 0 auto;
  margin-top: 19px;
  position: relative;
  z-index: 3;
}
.lookMore2 {
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #5E8C06;
  font-size: 14px;
  text-decoration: underline;
  margin: 0 auto;
  margin-top: 10px;
  padding-bottom: 15px;
}
.lookMore3 {
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #5E8C06;
  font-size: 14px;
  text-decoration: underline;
  margin: 0 auto;
  margin-top: 5px;
  padding-bottom: 15px;
  position: relative;
  z-index: 3;
}
.wanghongContent-it {
  width: 342px;
  height: 163px;
  background: #f1ffef;
  border-radius: 18px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  padding: 10px;
  margin-top: 10px;
  .wanghongContent-img {
    width: 168px;
    height: 106px;
    float: left;
    /deep/ .mint-swipe-indicators {
      display: none;
    }
    img {
      height: 100%;
      width: 100%;
    }
  }
  .wanghongContent-tp {
    background: #00a0c0;
    border-radius: 5px;
    color: #fff;
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    height: 27px;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
  }
  .wanghongContent-box {
    > img {
      width: 168px;
      height: 106px;
      float: left;
    }
    .wanghongContent-box-rt {
      width: calc(100% - 188px);
      margin-left: 10px;
      float: left;
    }
    .detail-btn {
      width: 100%;
      height: 32px;
      border: 1px solid #08536e;
      border-radius: 5px;
      color: #08536e;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5px;
      margin-top: 35px;
      font-size: 16px;
    }
    .vote-btn {
      width: 100%;
      height: 30px;
      background: #ffb119;
      border-radius: 5px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .vote-ticketNum {
      margin-bottom: 10px;
      width: 100%;
      height: 30px;
      background: #00a0c0;
      margin-bottom: 5px;
      border-radius: 5px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.hotelList {
  width: calc(100% - 24px);
  margin: 20px auto;
  margin-bottom: 0;
  &:before,
  &:after {
    content: '';
    display: block;
    clear: both;
  }
}
.hotelItem {
  width: calc(50% - 5px);
  background: #ffffff;
  border-radius: 5px;
  display: block;
  height: 192px;
  float: left;
  margin-right: 9px;
  margin-bottom: 9px;
  &:nth-child(2n + 2) {
    margin-right: 0;
  }
  &-tp {
    img {
      width: 100%;
      height: 95px;
    }
  }
  .hotelItem-btm {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 5px;
  }
  .hotelItem-cont {
    margin-bottom: 36px;
    padding: 10px 9px 0;
    font-size: 13px;
    text-align: left;
    -webkit-line-clamp: 1;
  }
  .hotelItem-price {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ff2f00;
    display: flex;
    align-items: flex-end;
    &:before {
      content: '¥';
      font-size: 10px;
      position: relative;
      bottom: 2px;
    }
    &:after {
      content: '起';
      font-size: 10px;
      position: relative;
      bottom: 2px;
    }
  }
  .hotelItem-look {
    width: 39px;
    height: 19px;
    background: #ff6600;
    border-radius: 7px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
  }
}
.bottom {
  width: 342px;
  margin: 0 auto;
  margin-top: 20px;
  display: block;
  padding-bottom: 50px;
}
</style>
